// v2017-12-21

import EzScrollToTop from "./_VueEzScrollToTop.vue";

export default {
  components: {
    EzScrollToTop
  }
};
